module.exports = __webpack_public_path__ + "img/logo-kbi-white.433278c3.svg";